import { Component } from "react";
import styles from "./inputCpf.module.css";
import TextField from "@material-ui/core/TextField";
import classnames from "classnames";
import { debounce } from "lodash";
import renderHTML from "html-react-parser";
import { _t } from "src/redux/store";
import { getIsCpfFree } from "src/redux/actions/action-register";

type Props = {
  classname?: string;
  name: string;
  value: string;
  label: string;
  info?: string;
  validateCpfFormat?: boolean;
  handleOnChange: Function;
};

type State = {
  value: string;
  input: {
    isValid: boolean;
    warning: string;
  };
};

class InputCpf extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: props.value || "",
      input: {
        isValid: true,
        warning: "",
      },
    };
    if (this.state.value){
      this.debouncedHandleOnChange();
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.value !== this.state.value) {
      this.debouncedHandleOnChange();
    }
    if (!!this.props.value && prevProps.value !== this.props.value){
      this.setState({
        value: this.props.value || ""
      });
    }
  }

  debouncedHandleOnChange = debounce(async () => {
    await this.validateInput(this.state.value);
    this.props.handleOnChange(this.props.name, this.state.value, this.state.input.isValid);
    
  }, 500);

  handleOnChange = (newValue: string, ) => {
    this.setState({ value: newValue || "" });
  };

  validateInput = async (text: string) => {
    text = text.trim();
    let cpf = text.replace(/[^\d]+/g,'');	
    let isValid = true;
    if (this.props.validateCpfFormat === true){
      if(cpf === '') {
        isValid = false;	
      }
      // Elimina CPFs invalidos conhecidos	
      if (cpf.length !== 11 || 
        cpf === "00000000000" || 
        cpf === "11111111111" || 
        cpf === "22222222222" || 
        cpf === "33333333333" || 
        cpf === "44444444444" || 
        cpf === "55555555555" || 
        cpf === "66666666666" || 
        cpf === "77777777777" || 
        cpf === "88888888888" || 
        cpf === "99999999999")
      {
        isValid = false;	
      }
  
      // Valida 1o digito	
      let add = 0;	
      for (let i=0; i < 9; i ++){
        add += parseInt(cpf.charAt(i)) * (10 - i);	
      }		
      let rev = 11 - (add % 11);	
      if (rev === 10 || rev === 11){
        rev = 0;	
      }		
  
      if (rev !== parseInt(cpf.charAt(9))){
        isValid = false;	
      }		
  
      // Valida 2o digito	
      add = 0;	
      for (let i = 0; i < 10; i ++){
        add += parseInt(cpf.charAt(i)) * (11 - i);	
      }		
  
      rev = 11 - (add % 11);	
      if (rev === 10 || rev === 11)	{
        rev = 0;	
      }
  
      if (rev !== parseInt(cpf.charAt(10))){
        isValid = false;	
      } 
    }
    if (isValid){
      const reponse = await getIsCpfFree(cpf);
      if (reponse.isFree === false){
        isValid = false;
      }
      this.setState({
        value: (isValid ? cpf : text ) || "",
        input: {
          isValid: isValid,
          warning: (isValid ? '' : _t.translate("Value already in use"))
        },
      });
     
    } else {
      this.setState({
        value: (isValid ? cpf : text ) || "",
        input: {
          isValid: isValid,
          warning: (isValid ? '' : _t.translate("Invalid CPF number"))
        },
      });
  
    }
   
  };

  render() {
    return (
      <div
        className={classnames(
          styles.formControl,
          typeof this.props.classname !== "undefined" && this.props.classname
        )}
      >
        <span className={styles.label}>{this.props.label}</span>
        <label className={styles.inputWrapper}>
        <TextField
            className={classnames(
              styles.textField,
              !this.state.input.isValid && styles.error
            )}
            onChange={(e) => this.handleOnChange(e.target.value)}
            value={this.state.value}
            InputProps={{
              className: styles.input,
              disableUnderline: true,
            }}
            type="tel"
          />
        </label>
        {typeof this.props.info !== "undefined" && (
          <div className={styles.info}>{renderHTML(this.props.info)}</div>
        )}
        {!this.state.input.isValid && (
          <small className={styles.warning}>{this.state.input.warning}</small>
        )}
      </div>
    );
  }
}

export default InputCpf;
